import Icon from './Icon';
import Modal from './Modal';

// ⋮ → חשוב לדעת on the two payment-tracking tabs. What the page shows, in the
// reader's words — and the one thing people got wrong: the payment itself
// happens OUTSIDE PEAK. Here you read how much to pay and record that it was
// paid, for tracking. Wording signed off by the owner (2026-09-04).
//
// One component, two variants, so the two tabs of one screen explain
// themselves in one voice.
const OPEN_TAB = (
  <>
    <p>
      מה רואים כאן: לכל ספק, כמה נשאר לשלם על המסמכים בתקופה שנבחרה - ואיפה הוא
      בתהליך. התשלום עצמו מתבצע מחוץ ל-PEAK; כאן רואים כמה יש לשלם ומתעדים
      שהתשלום בוצע, למעקב ולתיעוד.
    </p>
    <ul>
      <li><strong>לתשלום</strong> - הסכום שעדיין לא תועד כשולם. אם תועד חלק, מופיע מתחת "שולם X מתוך Y".</li>
      <li><strong>מצב תשלום</strong> - השלב של הספק: דורש בדיקה, ממתין לאישור, מאושר לתשלום, שולם חלקית, שולם. הסבר על כל שלב נמצא בסימן המידע (i) שליד כותרת העמודה.</li>
      <li><strong>תאריך לתשלום</strong> - לפי תנאי התשלום של הספק והמסמך האחרון שלו.</li>
    </ul>
    <p>
      <strong>אישור לתשלום - לפי ההתנהלות שלכם.</strong> PEAK לא מחייב לאשר לפני
      שמשלמים או מתעדים תשלום. אם במסעדה נהוג שמישהו בודק ומאשר לפני התשלום -
      השלב "מאושר לתשלום" מתעד מי אישר ומתי. אם משלמים ישירות - אפשר לדלג עליו,
      והספק יעבור ל"שולם" (מעבר עם העכבר על הסטטוס יראה "ללא אישור").
    </p>
    <p className="help-note">שימו לב: טיוטות לא נכללות בעמוד הזה - לא בשורות ולא בסכומים. הן מופיעות רק אחרי שאושרו.</p>
  </>
);

const PAID_TAB = (
  <>
    <p>
      מה רואים כאן: כל ספק שתועד לו תשלום בתקופה שנבחרה - כמה תועד כשולם, כמה
      עוד נשאר, ומתי היה התשלום האחרון. התשלום עצמו מתבצע מחוץ ל-PEAK; כאן נמצא
      התיעוד שלו.
    </p>
    <ul>
      <li><strong>שולם / לא שולם</strong> - כמה תועד כשולם, וכמה עדיין לא.</li>
      <li><strong>מצב תשלום</strong> - "שולם" או "שולם חלקית". אם התשלום תועד בלי שהחודש אושר קודם, מעבר עם העכבר על הסטטוס יראה "ללא אישור".</li>
      <li><strong>לחיצה על שורה</strong> - פותחת את המסמכים ששולמו ואת פרטי כל תשלום: אמצעי, תאריך, הערה ומי תיעד.</li>
    </ul>
    <p>
      <strong>אישור לתשלום - לפי ההתנהלות שלכם.</strong> PEAK לא מחייב לאשר לפני
      שמשלמים או מתעדים תשלום. "ללא אישור" הוא מידע בלבד, לא שגיאה.
    </p>
    <p className="help-note">שימו לב: טיוטות לא נכללות בעמוד הזה. מחיקת תיעוד תשלום אפשרית לאדמין בלבד, מתוך פרטי התשלום.</p>
  </>
);

const TITLES = { open: 'ספקים - מעקב תשלומים', paid: 'ספקים - היסטוריית תשלומים' };

export default function PaymentTrackingHelp({ tab = 'open', onClose }) {
  return (
    <Modal onClose={onClose} className="payment-help" size={520} ariaLabel={`חשוב לדעת · ${TITLES[tab]}`}>
      <h2 className="modal-title">חשוב לדעת · {TITLES[tab]}</h2>
    <div className="payment-help-body">{tab === 'paid' ? PAID_TAB : OPEN_TAB}</div>
    <div className="modal-actions">
      <button type="button" className="btn btn-secondary" onClick={onClose}><Icon name="x" size={15} /> סגור</button>
    </div>
    </Modal>
  );
}
